import { Badge } from '@workspace/ui/components/badge'
import type { FeedPreflight } from '../lib/feed-preflight'

interface FeedPreflightCardProps {
  fileName: string
  preflight: FeedPreflight
}

export function FeedPreflightCard({ fileName, preflight }: FeedPreflightCardProps) {
  return (
    <div className="rounded-2xl border border-border p-5">
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <div className="truncate text-sm font-semibold text-foreground">{fileName}</div>
          <div className="text-xs text-muted-foreground">
            {preflight.ok ? 'Every gate passes; ready to publish.' : 'This feed will be refused.'}
          </div>
        </div>
        <Badge variant={preflight.ok ? 'success' : 'destructive'} size="sm">
          {preflight.ok ? 'Ready' : 'Refused'}
        </Badge>
      </div>
      <ul className="mt-4 divide-y divide-border">
        {preflight.checks.map((check) => (
          <li key={check.label} className="flex items-start justify-between gap-3 py-2.5 text-sm">
            <div className="min-w-0">
              <div className="text-foreground">{check.label}</div>
              <div className="break-words text-xs text-muted-foreground">{check.detail}</div>
            </div>
            <Badge variant={check.ok ? 'success' : 'destructive'} size="sm">
              {check.ok ? 'Pass' : 'Fail'}
            </Badge>
          </li>
        ))}
      </ul>
    </div>
  )
}
